export type FoundObjectLinkedConversation = {
  unread_count?: number | null;
  announcement?: {
    object_attributes?: Record<string, unknown> | null;
    reference_code?: string | null;
  } | null;
};

/** Objet trouvé lié à une conversation (attributs ou référence FO-CONTACT-{id}). */
export function getFoundObjectIdFromConversation(
  conversation: FoundObjectLinkedConversation
): number | null {
  const attrs = conversation?.announcement?.object_attributes;
  const fromAttrs = Number(attrs?.found_object_id);
  if (Number.isFinite(fromAttrs) && fromAttrs > 0) return fromAttrs;

  const ref = String(conversation?.announcement?.reference_code ?? '');
  const match = ref.match(/^FO-CONTACT-(\d+)$/);
  if (match?.[1]) {
    const parsed = Number.parseInt(match[1], 10);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }

  return null;
}

/** Nombre de messages non lus par objet trouvé. */
export function buildFoundObjectUnreadCountMap(
  conversations: FoundObjectLinkedConversation[]
): Map<number, number> {
  const map = new Map<number, number>();
  for (const conversation of conversations) {
    const foundObjectId = getFoundObjectIdFromConversation(conversation);
    if (!foundObjectId) continue;
    const unread = conversation.unread_count ?? 0;
    if (unread <= 0) continue;
    map.set(foundObjectId, (map.get(foundObjectId) ?? 0) + unread);
  }
  return map;
}

export function getFoundObjectUnreadLabel(count: number): string {
  if (count <= 0) return '';
  if (count === 1) return 'Nouveau message';
  return `${count} non lus`;
}
